import { api } from '@/utils/api'

import { ApiResponseHandler, Gettable } from './ApiInterfaces'
import { ApiBase } from './ApiBase'

export namespace ApiTaSf060 {
  // GET parameters
  export namespace Get {
    // API Request
    export interface Request {
      query: {
        grade: number
      }
    }

    // API Response
    export interface Response {
      url: string
    }
  }

  // API Path
  const path: string = '/ta/getZproLink'

  // API本体
  export class Api extends ApiBase implements Gettable<Get.Request, Get.Response, undefined> {
    // GET
    public get<R>(
      params: Get.Request,
      successHandler: ApiResponseHandler<Get.Response, R>,
      errorHandler: ApiResponseHandler<undefined, R>
    ): Promise<R | null> {
      // 成功時のレスポンス構造サンプル
      const validationSample: Get.Response = {
        url: '',
      }

      // API呼び出し
      return this.callbackWrapper<Get.Response, undefined, R>(
        api.get<Get.Response>(path, { params: params.query }),
        successHandler,
        errorHandler,
        validationSample,
        undefined
      )
    }
  }
}
